import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import { useAuth } from '../context/AuthContext';

const useWichListFeedback = () => {
  const toast = useToast();
  const { user } = useAuth();
  const navigate = useNavigate();

  return useCallback((isAdded, sandwichName) => {
    if (!toast?.show) return;

    const safeName = sandwichName ? `"${sandwichName}"` : 'this sandwich';
    toast.show({
      message: isAdded
        ? `Added ${safeName} to your WichList`
        : `Removed ${safeName} from your WichList`,
      variant: isAdded ? 'success' : 'default',
      actionLabel: isAdded && user ? 'View list' : undefined,
      onAction:
        isAdded && user
          ? () => navigate(`/profile/${user.id}?tab=want-to-try`)
          : undefined
    });
  }, [toast, user, navigate]);
};

export default useWichListFeedback;


